import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=5761ff5c&scoped=true&"
import script from "./footer.ts?vue&type=script&lang=ts&"
export * from "./footer.ts?vue&type=script&lang=ts&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=5761ff5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5761ff5c",
  null
  
)

export default component.exports